module.exports = __webpack_public_path__ + "static/media/player-icon.7967bee6.svg";